import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs } from "../../base";
import { NavbarItemContainer } from "./navbar-item-container";
export var NavbarItem = Object.assign(forwardRefAs(function (props, ref) {
  return React.createElement(NavbarItemContainer, Object.assign({
    innerRef: ref
  }, props));
}, {
  as: "a"
}), {
  Container: NavbarItemContainer
});
NavbarItem.displayName = "Navbar.Item";
NavbarItem.propTypes = {
  active: PropTypes.bool,
  dropdown: PropTypes.bool,
  expanded: PropTypes.bool,
  hoverable: PropTypes.bool,
  managed: PropTypes.bool,
  onClick: PropTypes.func,
  tab: PropTypes.bool,
  up: PropTypes.bool
};